import { ConfigType } from "entities/config";
import { EncounterDetails } from "entities/issues";
import { Dispatch, SetStateAction, useState } from "react";
import EncountersTab from "./components/EncountersTab";
import LabsData from "./components/LabsData";
import { VitalsTab } from "./components/VitalsTab";

type EncounterPopoverContentProps = {
  encounter: EncounterDetails;
  tests?: ConfigType["tests"];
  vitals?: ConfigType["vitals"];
  handleCreateLabOrderClick: (id: string) => void;
};

type TabsProps = {
  setActivetab: Dispatch<SetStateAction<string>>;
  activeTab: string;
};

const Tabs = ({ setActivetab, activeTab }: TabsProps) => {
  return (
    <div className="bg-[#EFF1F3] h-[33px] px-[7px] rounded-lg ml-4 w-fit border flex items-center gap-2">
      <div
        role="button"
        onClick={() => setActivetab("encounter")}
        className={`w-fit px-2 py-1  ${
          activeTab == "encounter"
            ? "text-white bg-[#A82784] font-medium rounded"
            : "text-black font-semibold"
        } text-xs`}
      >
        <p>Encounter</p>
      </div>
      <div
        role="button"
        onClick={() => setActivetab("vitals")}
        className={`w-fit px-2 py-1  ${
          activeTab == "vitals"
            ? "text-white bg-[#A82784] font-medium rounded"
            : "text-black font-semibold"
        } text-xs`}
      >
        <p>Vitals</p>
      </div>
      <div
        role="button"
        onClick={() => setActivetab("lab")}
        className={`w-fit px-2 py-1  ${
          activeTab == "lab"
            ? "text-white bg-[#A82784] font-medium rounded"
            : "text-black font-semibold"
        } text-xs`}
      >
        <p>Lab Test</p>
      </div>
    </div>
  );
};

const EncounterPopoverContent = (props: EncounterPopoverContentProps) => {
  const { encounter, tests, vitals, handleCreateLabOrderClick } = props;
  const [activeTab, setActivetab] = useState("encounter");

  return (
    <div className="w-full text-black bg-[#ee83c5] md:w-[45rem] m-auto min-h-[25rem] relative border-0 rounded-xl border-black overflow-hidden md:max-w-full ">
      <div className="md:flex">
        <div className="sm:px-6 w-full">
          <div className="py-4">
            <div className="py-1 text-sm">
              <Tabs activeTab={activeTab} setActivetab={setActivetab} />
            </div>

            <div className="mt-7 overflow-x-auto">
              {activeTab === "encounter" && (
                <EncountersTab encounter={encounter} />
              )}

              {activeTab === "vitals" && (
                <VitalsTab vitals={vitals} vitalsData={encounter.vitals} />
              )}

              {activeTab === "lab" && (
                <LabsData
                  labsData={encounter.labs}
                  labs={tests}
                  onCreateClick={() => handleCreateLabOrderClick(encounter.id)}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EncounterPopoverContent;
